// queryClient.ts
import { QueryClient } from '@tanstack/react-query';
import { useErrorStore } from '../store/errorStore';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 60 * 1000,
      gcTime: 24 * 60 * 60 * 1000,
    },
  },
});

queryClient.getQueryCache().subscribe((event) => {
  // Only run if the query status is "error"
  if (event?.query?.state?.status === 'error') {
    useErrorStore.setState({ error: event.query.state.error });
  }
});

queryClient.getMutationCache().subscribe((event) => {
  if (event?.mutation?.state?.status === 'error') {
    useErrorStore.setState({ error: event.mutation.state.error });
  }
});
